.timezone {
  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: var(--rc-calendar-hour-width);
  border-right: var(--rc-calendar-border-base);
}

.timezone-label {
  max-width: 100%;
  padding: 0 4px;
  overflow: hidden;
  color: var(--rc-calendar-color-text-secondary);
  font-size: var(--rc-calendar-font-size-text-sm);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tooltip-portal {
  position: fixed;
  z-index: var(--rc-calendar-portal-z-index);
  padding: 6px 8px;
  transform: translate(-50%, calc(-100% - 8px));
  border-radius: var(--rc-calendar-border-radius-base);
  background: var(--rc-calendar-tooltip-background-color);
  color: var(--rc-calendar-color-surface-default);
  font-family: var(--rc-calendar-font-family);
  font-size: var(--rc-calendar-tooltip-font-size);
  white-space: nowrap;
  pointer-events: none;

  &::after {
    position: absolute;
    top: 100%;
    left: 50%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
    border-top: 4px solid var(--rc-calendar-tooltip-background-color);
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    content: '';
  }
}
